import { FormTemplate } from '@src/core';

const Collect2Form: FormTemplate = {
  title: 'Questionário Puérpera',
  subtitle: 'Questionário 2: de 8 a 10 dias pós-parto',
  initialMessage:
    'Olá, tudo bem? <br/><br/> Primeiramente, obrigado por estar dedicando um tempo para nos ajudar com a pesquisa! <br/><br/>A seguir, faremos algumas perguntas sobre seu processo de recuperação neste período de <b>8 a 10 dias pós parto</b>.Por favor, selecione as respostas que mais fielmente representam seu estado atual, especialmente em relação à recuperação na área com pontos onde você foi suturada.<br/><br/>Durante as questões, você notará que mencionaremos a palavra "DOR" algumas vezes. Sempre que isso ocorre, estamos nos referindo a qualquer tipo de desconforto ou sensação incômoda associada aos pontos no períneo/vagina.<br/><br/>Vamos lá?',
  endedMessage:
    'Muito obrigado por ter respondido nossa pesquisa do projeto XPTO! 🤩 <br/><br/>Sua ajuda faz toda a diferença para nós e para muitas outras mulheres.',
  step: {
    title: 'Avaliação',
    questions: {
      question01: {
        sequence: 1,
        type: 'radio',
        label: '1. Como você diria que está se sentindo fisicamente?',
        options: ['Muito Bem', 'Razoavelmente bem', 'Não muito bem', 'Nada bem'],
        validator: {
          dataType: 'string',
          required: true,
        },
        fullWidth: true,
      },

      question02: {
        sequence: 2,
        type: 'radio',
        label:
          '2. Você precisou tomar algum analgésico para a dor ou desconforto da área onde foi suturada/com pontos?',
        options: ['Sim', 'Não'],
        validator: {
          dataType: 'string',
          required: true,
        },
        fullWidth: true,
      },

      question03: {
        sequence: 3,
        type: 'checkbox',
        label:
          '3. Nas últimas 24 horas, você precisou fazer uso de algum método para aliviar dor ou desconforto dos pontos?',
        helperText: '(marque todas as opções aplicáveis)',
        options: [
          'Precisei procurar ajuda em um hospital',
          'Utilizei métodos naturais que foram suficientes',
          'Utilizei analgésico que tenho em casa',
        ],
        validator: {
          dataType: 'array',
          required: true,
          min: { value: 1, errorMessage: 'Selecione pelo menos UMA opção' },
        },
        fullWidth: true,
      },
    },
  },
};

export { Collect2Form };
